import Icon from "@mui/material/Icon";
import i18next from "i18next";
import { isAuthenticated } from "utils/auth";

// Build routes dynamically based on the *current* language.
// IMPORTANT: This must be called inside a React component (or whenever language changes)
// so that the navbar updates immediately without a hard refresh.
export function getRoutes(rawLang) {
  const resolvedRaw = rawLang || i18next.language || localStorage.getItem("i18nLanguage") || "en";
  const lang = String(resolvedRaw).toLowerCase();
  const isZh = lang.startsWith("zh");

  const hasToken = isAuthenticated();

  // Pricing section lives on:
  // - /userinfo/#pricing when logged in
  // - /#pricing when not logged in
  const pricingHref = hasToken ? "/userinfo/#pricing" : "/#pricing";

  return [
    {
      key: "pricing",
      name: isZh ? "价格" : "Pricing",
      href: pricingHref,
      icon: <Icon>attach_money</Icon>,
    },
    {
      key: "faq",
      name: isZh ? "常见问题" : "FAQ",
      route: "/faq",
      icon: <Icon>help_outline</Icon>,
    },
    {
      key: "contact",
      name: isZh ? "联系我们" : "Contact Us",
      icon: <Icon>contact_mail</Icon>,
      collapse: [
        { key: "wechat", name: isZh ? "微信客服" : "WeChat", href: "#" },
        { name: isZh ? "Telegram 电报" : "Telegram", href: "https://t.me/zionladder" },
        { name: isZh ? "电子邮件" : "Email", href: "mailto:support@zionladder.com" },
      ],
    },
    {
      key: "download",
      name: isZh ? "下载客户端" : "Download",
      icon: <Icon>download</Icon>,
      collapse: [
        { name: "iPhone / iPad", href: "/client/ios/" },
        { name: isZh ? "安卓" : "Android", href: "/client/android/" },
        { name: "Windows", href: "/client/windows/" },
        { name: "macOS", href: "/client/macos/" },
        {
          name: isZh ? "Android TV / 智能电视" : "Android TV / Smart TV",
          href: "/client/android_tv/",
        },
        { name: "Apple TV", href: "/client/apple_tv/" },
        { name: "OpenWrt", href: "/client/openwrt/" },
        { name: isZh ? "华硕梅林" : "ASUS Merlin", href: "/client/merlin/" },
        { name: "Linux", href: "/client/linux/" },
        { name: isZh ? "第三方应用" : "Third-Party Apps", href: "/client/thirdparty/" },
      ],
    },
  ];
}

// Backward-compatible default export: an array of routes
const routes = getRoutes();
export default routes;
